import script from "./income.vue?vue&type=script&setup=true&lang=js"
export * from "./income.vue?vue&type=script&setup=true&lang=js"

import "./income.vue?vue&type=style&index=0&id=161db356&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161db356"]])

export default __exports__